import { Stack, Tabs, Text } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Content } from '@/core/components';

import { Id } from '@/feature/utils';

import { JournalAisMetricTable } from './JournalAisMetricTable';
import { JournalAisRankTable } from './JournalAisRankTable';

interface JournalArticleInfluenceScoreViewProps {
  journalId: Id;
  journalName: string;
}

export function JournalArticleInfluenceScoreView(props: JournalArticleInfluenceScoreViewProps) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string | null>('metrics');

  return (
    <Stack>
      <Content type="full">
        {' '}
        <Text fw="500">
          {props.journalName} - {t('journals.reputation.articleInfluenceScore.view')}
        </Text>
      </Content>

      <Content type="full">
        <Tabs
          value={activeTab}
          onChange={setActiveTab}
        >
          <Tabs.List>
            <Tabs.Tab value="metrics">{t('journals.reputation.articleInfluenceScore.tabs.metrics')}</Tabs.Tab>

            <Tabs.Tab value="ranks">{t('journals.reputation.articleInfluenceScore.tabs.ranks')}</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="metrics">
            {activeTab === 'metrics' && <JournalAisMetricTable journalId={props.journalId} />}
          </Tabs.Panel>
          <Tabs.Panel value="ranks">
            {activeTab === 'ranks' && <JournalAisRankTable journalId={props.journalId} />}
          </Tabs.Panel>
        </Tabs>
      </Content>
    </Stack>
  );
}
